import { Get, Set } from "../../Request";

export const GetData = async () => {
  return await Get({
    url: "/data/footer",
    // data: {
    //   limit: limit,
    // },
    // page: page,
  }).then(data => {
    return data;
  });
};
export const SendEmail = async (data) => {
  return await Set({
    url: "/emailnewsletter/store",
    data
  }).then(res => {
    return res;
  });
};
